import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";
import {
    GetPatientItemIdentityByIdRequest,
    type GetPatientItemIdentityByIdResponse,
    type IReturn,
} from "src/api/Tmd.dtos";
import useApi from "src/hooks/api/useApi";

const usePatientItemIdentityById = (
    id?: number | null,
    configuration?: SWRConfiguration<
        GetPatientItemIdentityByIdResponse,
        GetPatientItemIdentityByIdResponse
    > | null,
) => {
    const getRequest = useMemo(() => {
        if (!id) return undefined;
        return (): IReturn<GetPatientItemIdentityByIdResponse> =>
            new GetPatientItemIdentityByIdRequest({ id });
    }, [id]);

    return useApi(
        "get",
        getRequest,
        {
            getData: (response?: SWRResponse<GetPatientItemIdentityByIdResponse>) =>
                response?.data?.patientItemIdentity,
            getError: (response?: SWRResponse<GetPatientItemIdentityByIdResponse>) =>
                (response?.error ?? response?.data)?.responseStatus,
            getAdditionalState: () => ({}),
        },
        configuration,
    );
};

export default usePatientItemIdentityById;
